import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {StatisticState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: StatisticState = {
    groupBy: [
        'hour',
        'day',
        'week',
        'month',
    ],
    groupByOptionally: [
        'partner',
        'service_provider',
        'originator',
        'operator',
        'template_id',
        'bulk_id',
        'message_category',
        'broker_account_login',
        'message_type',
    ],
    smsStatisticGroup: null,
    smsStaticDetail: null,
    smsStaticDetailFlag: '',
};


export const smsStatistic: Module<StatisticState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
